import { HistoryDto, IdentityDto } from './../../shared';

export class ClusterEntityDto {
  entityType: string;
  history: HistoryDto;
  identity: IdentityDto;
  source: string;

  constructor(d?: ClusterEntityDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);

    if (d.history) {
      this.history = new HistoryDto(d.history);
    }

    if (d.identity) {
      this.identity = new IdentityDto(d.identity);
    }
  }
}
